if (!customElements.get('quickbuy-popup')) {
  class QuickbuyPopup extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
      this.currentAbortController = null;
    }

    handleClick(evt) {
      if (evt.target === this || evt.target.matches('.js-close-modal')) {
        this.close();
      }
    }

    open(opener) {
      this.setAttribute('open', '');
      this.openedBy = opener;

      this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();
      this.addEventListener('keyup', this.keyupHandler);

      if (typeof trapFocus === 'function') {
        trapFocus(this);
      }
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }
    }

    close() {
      this.removeAttribute('open');

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.openedBy);
      }
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }

      this.removeEventListener('keyup', this.keyupHandler);

      setTimeout(() => {
        const content = this.querySelector('.quickbuy-popup__content');
        if (content) content.innerHTML = '<div class="loading-spinner"></div>';
      }, 400);
    }

    loadProduct(productUrl, opener) {
      this.open(opener);

      if (this.currentAbortController) {
        this.currentAbortController.abort('New product loading');
      }
      this.currentAbortController = new AbortController();

      this.dataset.productUrl = productUrl;

      const content = this.querySelector('.quickbuy-popup__content');
      content.innerHTML = '<div class="loading-spinner"></div>';

      fetch(productUrl, {
        method: 'get',
        signal: this.currentAbortController.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = html;
          const productContent = tmpl.content.querySelector('.quickbuy-content');
          if (!productContent) {
            content.innerHTML = '<p>Unable to load product.</p>';
            return;
          }

          const newDetail = productContent.cloneNode(true);

          tmpl.content.querySelectorAll('.section-size-guide').forEach((el) => {
            if (el.querySelector('.modal--for-size-guide')) {
              newDetail.insertAdjacentElement('beforeend', el.cloneNode(true));
            } else {
              const modalTmpl = el.querySelector('[data-modal-template]');
              if (modalTmpl) {
                const sizeGuide = modalTmpl.content.querySelector('size-guide').cloneNode(true);
                const guideContent = el.querySelector('.size-guide__content');
                if (guideContent) sizeGuide.querySelector('.modal__content').appendChild(guideContent);
                newDetail.insertAdjacentElement('beforeend', sizeGuide);
              }
            }
          });

          if (theme.quickBuy && theme.quickBuy.convertToQuickBuyContent) {
            theme.quickBuy.convertToQuickBuyContent(newDetail, productUrl);
          }

          tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) link[rel="stylesheet"]').forEach((el) => {
            if (!document.querySelector(`link[rel="stylesheet"][href="${el.getAttribute('href')}"]`)) {
              document.head.insertAdjacentHTML('beforeend', el.outerHTML);
            }
          });
          tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) script[src]').forEach((el) => {
            if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
              const scr = document.createElement('script');
              scr.src = el.getAttribute('src');
              scr.defer = 'defer';
              document.head.appendChild(scr);
            }
          });

          content.innerHTML = '';
          content.appendChild(newDetail);

          this.listenForCartAdd(content);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') {
            console.warn(error); // eslint-disable-line no-console
            content.innerHTML = '<p>Unable to load product.</p>';
          }
        });
    }

    listenForCartAdd(container) {
      container.addEventListener('on:cart:add', () => {
        setTimeout(() => this.close(), 300);
      });

      const productForm = container.querySelector('product-form');
      if (productForm) {
        const origAfterAdd = theme.settings.afterAddToCart;

        productForm.addEventListener('submit', () => {
          const qbBehavior = theme.quickBuy.getAfterAddBehavior();
          theme.settings.afterAddToCart = qbBehavior;
        });

        productForm.addEventListener('on:cart:add', () => {
          theme.settings.afterAddToCart = origAfterAdd;
        });

        productForm.addEventListener('on:cart:error', () => {
          theme.settings.afterAddToCart = origAfterAdd;
        });
      }
    }
  }

  customElements.define('quickbuy-popup', QuickbuyPopup);
}
